module.exports = __webpack_public_path__ + "img/nodata.e12f8e8d.png";